import { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
import { SaleEntity } from "../entities/SaleEntity";

async function getUserStaff({
  page = 1,
  take = 10,
  keyword,
  isActive,
  company,
  statusApprove,
}: {
  page?: number;
  take?: number;
  keyword?: any;
  isActive?: "ACTIVE" | "INACTIVE";
  company?: "ICPI" | "ICPL" | "ICPF" | "ICK";
  statusApprove?: "WAIT_APPROVE" | "APPROVED" | "REJECTED";
}) {
  const query: any = {
    page,
    take,
    company,
  };
  if (keyword) {
    query.text = keyword;
  }
  if (isActive) {
    query.isActive = isActive;
  }
  if (statusApprove) {
    query.statusApprove = statusApprove;
  }
  const genQuery = new URLSearchParams(query).toString();

  const url = `${BASE_URL}/auth/user-staff?${genQuery}`;

  return await httpClient.get(url).then((res: AxiosResponse) => res.data);
}
const updateUserStaff = async (id: string, data: SaleEntity) => {
  const url = `${BASE_URL}/auth/user-staff/${id}`;
  return await httpClient.patch(url, data).then((res: AxiosResponse) => {
    return res.data;
  });
};

const createNewSaleStaff = async (data: SaleEntity) => {
  const url = `${BASE_URL}/auth/user-staff`;
  return await httpClient.post(url, data).then((res: AxiosResponse) => res.data);
};
const deleteSaleStaff = async (id?: string) => {
  const url = `${BASE_URL}/auth/user-staff/${id}`;
  return await httpClient.delete(url).then((res: AxiosResponse) => res.data);
};

const getSaleStaffById = async (id?: string) => {
  const url = `${BASE_URL}/auth/user-staff/${id}`;
  return await httpClient.get(url).then((res: AxiosResponse) => res.data);
};
const uploadProfile = async (data: FormData) => {
  return await httpClient
    .post(`${BASE_URL}/auth/user-staff/update-profile`, data)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const checkTelEmail = async (email?: string, telephone?: string) => {
  try {
    const url = `${BASE_URL}/auth/user-staff/validate-telephone-email`;
    const params = {};
    if (email) params["email"] = email;
    if (telephone) params["telephone"] = telephone;

    const response = await httpClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Error in checkTelEmail:", error);
    throw new Error("เกิดข้อผิดพลาดในการตรวจสอบเบอร์โทรศัพท์หรืออีเมล");
  }
};
const sendMailAgain = async (id?: string) => {
  const url = `${BASE_URL}/auth/user-staff/send-mail-again/${id}`;
  return await httpClient.get(url).then((res: AxiosResponse) => res.data);
};

const uploadSignImage = async (userStaffId: string, signImage: File) => {
  const formData = new FormData();
  formData.append("userStaffId", userStaffId);
  formData.append("signImage", signImage);

  const url = `${BASE_URL}/auth/user-staff/upload-sign-image`;
  return await httpClient.post(url, formData).then((res: AxiosResponse) => res.data);
};
const deleteSignImage = async (userStaffId: string) => {
  const url = `${BASE_URL}/auth/user-staff/delete-file-sign-image/${userStaffId}`;
  return await httpClient.delete(url).then((res: AxiosResponse) => res.data);
};
export const SaleListDatasource = {
  getUserStaff,
  updateUserStaff,
  createNewSaleStaff,
  getSaleStaffById,
  deleteSaleStaff,
  uploadProfile,
  checkTelEmail,
  sendMailAgain,
  uploadSignImage,
  deleteSignImage,
};
